module.exports = __webpack_public_path__ + "static/media/Glúteos.56bb52af.png";